'use client'

import MUIStack from '@mui/material/Stack'

export const HoverActionsPill = ({ children, top, padding, height, right }: HoverActionsPillProps) => {
  return (
    <MUIStack
      data-testid="HoverActionsPill"
      direction="row"
      alignItems="center"
      gap={1}
      className="hoverActionsPill"
      sx={{
        position: 'absolute',
        top: top ?? '9px',
        right: right ?? '9px',
        backgroundColor: 'white',
        height: height ?? '42px',
        borderRadius: '23px',
        padding: padding ?? '3px 5px',
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
        opacity: 0,
        visibility: 'hidden',
        transition: 'opacity 0.2s'
      }}
    >
      {children}
    </MUIStack>
  )
}

type HoverActionsPillProps = {
  children: React.ReactNode
  top?: string | number
  padding?: string
  height?: string | number
  right?: string | number
}
